import { Box, Grid, List, makeStyles, Typography } from "@material-ui/core"
import React from "react"
import ReactMarkdown from "react-markdown"
import { EmbedVideo } from "../utils/embed-video"
import { PicturesWithLightBox } from "../utils/pictures-with-lightbox"

const useStyles = makeStyles(theme => ({
  imageContainer: {
    cursor: "pointer",
    filter: "brightness(0.9)",
    width: "80vh",
    transition: "filter 300ms ease-in-out",
    border: "1px solid #111",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    "&:hover": {
      filter: "brightness(1)",
    },
  },
  image: {
    width: "80%",
  },
  galleryContainer: {
    display: "flex",
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  detailContainer: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "32px",
      padding: 0,
    },
  },
  textContainer: {
    paddingRight: "96px",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },
}))

export const WorkPageContent = ({
  data: { title, description, video, infos, pictures },
}) => {
  const classes = useStyles()
  const components = {
    p: ({ children }) => <Typography variant="body1">{children}</Typography>,
    ul: ({ children }) => (
      <List style={{ textEmphasisColor: "#F26522" }}>{children}</List>
    ),
    a: ({ node, ...props }) => (
      <a
        style={{
          color: "#F26522",
          textDecoration: "none",
        }}
        {...props}
      />
    ),
  }
  return (
    <Box>
      <Box mt={12} mb={8}>
        <Box mb={5} pr={8}>
          <Typography variant="h2">{title ? title : "About"}</Typography>
        </Box>
        <Grid container>
          {title || description ? (
            <Grid md={8} item>
              <Box className={classes.textContainer}>
                <ReactMarkdown linkTarget="_blank" components={components}>
                  {description}
                </ReactMarkdown>
              </Box>
            </Grid>
          ) : (
            <Box></Box>
          )}
          <Grid
            sm={12}
            md={title || description ? 3 : 12}
            item
            className={classes.detailContainer}
          >
            <Box
              display="flex"
              flexWrap="wrap"
              flexDirection={title || description ? "column" : "row"}
            >
              {infos.map(info => (
                <Box mb={3} mr={title || description ? 0 : 8}>
                  <Typography variant="caption">{info.name}</Typography>
                  <Typography variant="h3">{info.value}</Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>
      {pictures[0] && (
        <Box mb={8}>
          <PicturesWithLightBox pictures={pictures} />
        </Box>
      )}
      <Box mb={16}>
        <Typography variant="h3">Video</Typography>
        <Box mt={2}>
          <EmbedVideo src={video} />
        </Box>
      </Box>
    </Box>
  )
}
